import {put} from 'redux-saga/effects';
import {uiActions} from "../../actions";

export function* toast(action: any){
  yield put(uiActions.fillToastData(action.payload));
  yield put(uiActions.toastOpen());
}
